<template>

    <div class="page-center content-load animated fadeIn">

        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-xl-6 col-xl-offset-3 col-md-6 col-md-offset-3">

                    <div class="login-register-page">

                        <center>
                            <img src="static/images/logo.png" width="180" class="logo margin-bottom-20">
                        </center>                        
                        
                        <div class="welcome-text margin-bottom-30 margin-top-10">
                            <h3 class="margin-bottom-10">
                                <ion-icon name="person-add-outline"></ion-icon>
                                Cadastro para <b>entregadores</b>
                            </h3>
                            <span>
                                
                            </span>
                        </div>

                        <form method="post" id="register-account-form" v-on:submit.prevent="submit" novalidate="">
                            
                            <div class="dashboard-box margin-top-0 mobile">

                                <div class="content with-padding">

                                    <div class="row">                                                               
                                        <!-- <div class="hidden-xs margin-top-20 col-xl-12"></div> -->

                                        <div class="col-xs-12 margin-top-10">
                                            <div class="submit-field margin-bottom-20">
                                                <div class="checkbox">
                                                    <input type="checkbox" id="aluguel-moto" v-model="form.aluguelMoto" value="1">
                                                    <label for="aluguel-moto" style="text-transform: uppercase; font-size: 14px; line-height: 130%; padding-top: 2px;"><span class="checkbox-icon"></span> Quer alugar uma moto na susten? Marque aqui.</label>
                                                </div>                                            
                                            </div>
                                        </div>

                                        <div class="col-lg-12 col-xs-12 margin-top-0">    
                                            <div  class="submit-field margin-top-0 margin-bottom-0">
                                                <h5>
                                                    Nome completo
                                                    <b class="opcional-obrigatorio">(obrigatório)</b>
                                                </h5>
                                            </div>                                                 
                                        </div>
                                        <div class="col-lg-11 col-xs-12">
                                            <div class="input-with-icon-left">
                                            <i>
                                                <ion-icon name="person-outline"></ion-icon>
                                            </i>                                                      
                                                <input type="text" class="input-text with-border" autocomplete="new-password" v-model="form.nome" name="nome" autocapitalize="words" id="nome" placeholder="Escreva seu nome aqui.." required/>
                                            </div>          
                                        </div>    

                                        <div class="col-lg-12 col-xs-12">
                                            <div class="submit-field margin-top-0 margin-bottom-0">
                                                <h5>
                                                    E-mail
                                                    <b class="opcional-obrigatorio">(obrigatório)</b>
                                                </h5>
                                            </div>
                                        </div>                                
                                        <div class="col-lg-10 col-xs-12">
                                            <div class="input-with-icon-left">
                                                <i>
                                                    <ion-icon name="mail-outline"></ion-icon>
                                                </i>
                                                <input type="email" class="input-text with-border" autocomplete="new-password" v-model="form.email" name="email" id="email" placeholder="Escreva seu e-mail" required/>
                                            </div>              
                                        </div>  
                                        <!-- <div class="col-lg-12 col-xs-12"> -->
                                        <div class="col-lg-6 col-xs-10">
                                            <div class="submit-field margin-top-0 margin-bottom-0">
                                                <h5>
                                                    Telefone
                                                    <b class="opcional-obrigatorio">(obrigatório)</b>
                                                </h5>
                                            </div>                            
                                            <div class="input-with-icon-left">
                                                <i>
                                                    <ion-icon name="call-outline"></ion-icon>
                                                </i>
                                                <the-mask :mask="['(##) #####-####','(##) ####-####']"  type="tel" class="with-border input-text" placeholder="(__) ____-____" autocomplete="new-password" v-model="form.telefone" />
                                            </div>
                                        </div>
                                                                        
                                        <div class="col-xl-5 col-md-4 col-lg-5 col-xs-10">
                                            <div class="submit-field margin-top-0 margin-bottom-0">
                                                <h5 >
                                                    CPF 
                                                    <b class="opcional-obrigatorio">(obrigatório)</b>
                                                </h5>
                                            </div>
                                            <div class="input-with-icon-left">
                                                <i>
                                                    <ion-icon name="shield-checkmark-outline"></ion-icon>
                                                </i>
                                                <the-mask type="tel" :mask="['###.###.###-##']" class="with-border input-text" v-model="form.doc" :placeholder="'___.___.___-__'"/>
                                            </div>                                                    
                                        </div>  

                                        <div class="col-xl-5 col-md-6 col-lg-6 col-xs-10" >
                                            <div class="submit-field margin-top-0 margin-bottom-0">
                                                <h5>
                                                    Data de nascimento
                                                    <b class="opcional-obrigatorio">(opcional)</b>
                                                </h5>
                                            </div>

                                            <div class="input-with-icon-left">
                                                <i>
                                                    <ion-icon name="calendar-outline"></ion-icon>
                                                </i>
                                                <the-mask :mask="['##/##/####']" :masked="true" type="tel" class="input-text with-border" autocomplete="new-password" v-model="form.dataNascimento" placeholder="__ /__ /____" required />
                                            </div>                                                    
                                        </div>                                                                                        
                                      
                                        <div class="col-lg-12 col-xs-12">
                                            <div class="submit-field margin-top-0 margin-bottom-0">
                                                <h5>
                                                    Senha 
                                                    <b class="opcional-obrigatorio">(obrigatório)</b>
                                                </h5>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-xs-10">
                                            <div class="input-with-icon-left" title="Pelo menos 8 caracteres" data-tippy-placement="bottom">
                                                <i>
                                                    <ion-icon name="lock-closed-outline"></ion-icon>
                                                </i>
                                                <input type="password" class="input-text with-border" autocomplete="new-password" v-model="form.senha" name="senha" id="password-register" placeholder="Escreva uma senha" required/>
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-xs-10">
                                            <div class="input-with-icon-left">
                                                <i>
                                                    <ion-icon name="lock-closed-outline"></ion-icon>
                                                </i>
                                                <input type="password" class="input-text with-border" autocomplete="new-password" v-model="form.senhaConfirmacao" name="senhaConfirmacao" id="password-repeat-register" placeholder="Repita a senha" required/>
                                            </div>
                                        </div>

        
                                        <div class="col-xl-12 margin-top-5 margin-bottom-20" >
                                            <!-- Headline -->
                                            <div class="headline" style="display: block; padding-left: 0px !important; padding-bottom: 10px">
                                                <h3 >
                                                    <ion-icon name="location-outline"></ion-icon>
                                                    Endereço
                                                </h3>
                                            </div>
                                        </div>

                                        <div  class="col-xl-5 col-lg-5 col-xs-7">
                                            <div class="submit-field">
                                                <h5>CEP <b class="opcional-obrigatorio">(obrigatório)</b></h5>
                                                <the-mask :mask="['#####-###']" :masked="true" autocomplete="new-password" type="tel" class="with-border" v-model="form.cep" placeholder="Informe seu CEP" />
                                            </div>
                                        </div>

                                        <div  class="col-xl-12 col-xs-12">
                                            <div class="submit-field">
                                                <h5>Rua <b class="opcional-obrigatorio">(obrigatório)</b></h5>
                                                <input type="text" class="with-border" autocomplete="new-password" placeholder="Escreva seu endereço" v-model="form.endereco">
                                            </div>
                                        </div>

                                        <div  class="col-xl-3 col-lg-3 col-xs-5">
                                            <div class="submit-field">
                                                <h5>Número <br class="hidden-xs"><b class="opcional-obrigatorio">(opcional)</b></h5>
                                                <input type="tel" class="with-border" autocomplete="new-password" placeholder="" v-model="form.numero">
                                            </div>
                                        </div>

                                        <div  class="col-xl-8 col-xs-12">
                                            <div class="submit-field">
                                                <h5>Complemento <br class="hidden-xs"><b class="opcional-obrigatorio">(opcional)</b></h5>
                                                <input type="text" class="with-border" autocomplete="new-password" placeholder="" v-model="form.complemento">
                                            </div>
                                        </div>
                                
                                
                                        <div  class="col-xl-6">
                                            <div class="submit-field">
                                                <h5>Bairro <b class="opcional-obrigatorio">(obrigatório)</b></h5>
                                                <input type="text" class="with-border" autocomplete="new-password" placeholder="Informe seu bairro" v-model="form.bairro">
                                            </div>
                                        </div>

                                        <div  class="col-xl-6">
                                            <div class="submit-field">
                                                <h5>Cidade <b class="opcional-obrigatorio">(obrigatório)</b></h5>
                                                <input type="text" class="with-border" readonly="" placeholder="Informe sua cidade" v-model="form.cidade">
                                            </div>
                                        </div>

                                        <div  class="col-xl-6">
                                            <div class="submit-field">
                                                <h5>Estado <b class="opcional-obrigatorio">(obrigatório)</b></h5>
                                                <select id="estado" class="with-border" readonly="" name="estado" required="" v-model="form.estado">
                                                    <option value="" disabled selected hidden>Estado</option>
                                                    <option value="AC">Acre</option>
                                                    <option value="AL">Alagoas</option>
                                                    <option value="AP">Amapá</option>
                                                    <option value="AM">Amazonas</option>
                                                    <option value="BA">Bahia</option>
                                                    <option value="CE">Ceará</option>
                                                    <option value="DF">Distrito Federal</option>
                                                    <option value="ES">Espírito Santo</option>
                                                    <option value="GO">Goiás</option>
                                                    <option value="MA">Maranhão</option>
                                                    <option value="MT">Mato Grosso</option>
                                                    <option value="MS">Mato Grosso do Sul</option>
                                                    <option value="MG">Minas Gerais</option>
                                                    <option value="PA">Pará</option>
                                                    <option value="PB">Paraíba</option>
                                                    <option value="PR">Paraná</option>
                                                    <option value="PE">Pernambuco</option>
                                                    <option value="PI">Piauí</option>
                                                    <option value="RJ">Rio de Janeiro</option>
                                                    <option value="RN">Rio Grande do Norte</option>
                                                    <option value="RS">Rio Grande do Sul</option>
                                                    <option value="RO">Rondônia</option>
                                                    <option value="RR">Roraima</option>
                                                    <option value="SC">Santa Catarina</option>
                                                    <option value="SP">São Paulo</option>
                                                    <option value="SE">Sergipe</option>
                                                    <option value="TO">Tocantins</option>
                                                </select>                                                   
                                            </div>
                                        </div>

                                        <div class="col-xl-12 margin-top-15">
                                            <p class="margin-bottom-0" style="font-size: 14px; line-height: 130%;">
                                                <ion-icon name="document-outline"></ion-icon>         
                                                Ao efetuar seu cadastro, você concorda com os nossos <a v-on:click="$root.openModal('modal-termos-de-uso')"><b>Termos de Uso</b></a> e a <a v-on:click="$root.openModal('modal-politicas-de-privacidade')"><b>Política de Privacidade</b></a>.
                                            </p>
                                        </div>

                                        <div class="col-lg-12 col-xs-12">
                                            <button class="button full-width margin-top-20 margin-bottom-10" type="submit">
                                                Efetuar cadastro
                                                <ion-icon name="chevron-forward-outline"></ion-icon>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br>
                                
                        </form>

                        
                    </div>

                </div>
            </div>
        </div>  
    </div>
</template>

<script>
export default {
    name:                           'Cadastro',
    data () {
        var self                    = this;
        return {
            termos:                 true,
            loading: {
                "submit":           false,
            },
            form: {
                "nome":             null,
                "email":            null,
                "tipo":             "entregador",
                "telefone":         "",
                "empresa":          "",
                "doc":              "",
                "aluguelMoto":      false,
                "cnpj":             "",
                "razaoSocial":      "",
                "dataNascimento":   null,
                "estado":           "",
                "senha":            null,
                "senhaConfirmacao": null,
                "dispositivo":      self.$root.mobile.osName
            }
        }
    },
    watch: {
        "form.cep": function(val) {
            var self = this;
            self.atualizarCEP(val);
        },
    },    
    methods: {
        atualizarCEP: function(val) {
            var self    = this;
            if (val) {
                if (val.length == 9) {
                    axios.get("https://viacep.com.br/ws/" + val.replace("-", "") + "/json/", {})
                    .then(response => {
                        if (response.data) {
                            if (response.data.logradouro) {
                                self.form.endereco  = response.data.logradouro;
                                self.form.bairro    = response.data.bairro;
                                self.form.cidade    = response.data.localidade;
                                self.form.estado    = response.data.uf;
                                self.$forceUpdate();
                            }
                        }
                    })
                    .catch(error => {
                    });
                }
            }
        },        
        submit: function(e) {
            // return false; // TODO DEMO
            var self            = this;
            if (!self.termos) return false;
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            axios.post("api/cadastro.php", self.form)
            .then(response => {
                // self.loading.submit = false;
             
                if (response.data.user) {
                    self.$root.setUser(response.data.user).then(function() {
                        // self.$router.push({"name": "Dashboard"});
                        setTimeout(function() {
                            window.location.reload();
                        }, 200);
                    })
                } else {
                    loading.hide();
                }
            })
            .catch(error => {
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        }
    },
    mounted: function() {
        loading.hide();
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
    .current-page-cadastro .loading {
        top: 0px !important;
    }   

    .current-page-cadastro {
        background-image: url(/static/images/bg3.png);
        background-size: cover;
        background-repeat: repeat;
        background-position: center;
    }
    .page-cadastro #wrapper {
        background: #fe0100 !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }   

   
    .page-cadastro .container {
        margin-top: 35px !important;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 20px;
    }
    .page-cadastro input {
        margin-bottom: 7px;
    }
    .page-cadastro .input-with-icon-left i {
        background: transparent;
        border-right: none;
    }
    .page-cadastro .input-with-icon-left i {
        color: #fe0100;
    }
    .page-cadastro .selo {
        bottom: 0px;
        width: 100%;
        display: block;
        margin-top: 0px;
        text-transform: uppercase;
        font-size: 10px;
        margin-bottom: 10px;
        text-align: center;
        letter-spacing: 0px;
        color: #444;
    }
    .page-cadastro .section-headline {
        padding-right: 0px;
    }       
    .page-cadastro .button.small.block-mobile ion-icon {
        font-size: 30px;
    }
    .page-cadastro .button.small.block-mobile {
        line-height: 130%;
        font-weight: 400;
        padding-top: 10px;
        padding-bottom: 10px;
        text-align: center;
        background: #fff;
        border: 1px solid #EFEFEF;
        color: #555;
    }
    .page-cadastro .welcome-text h3 ion-icon {
        color: #fff !important;

    }
    .page-cadastro .welcome-text h3 {
        color: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cadastro.vue